module.exports = __webpack_public_path__ + "static/img/blank-wall.97568f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/blank-wall.png
// module id = 76ri
// module chunks = 1